import generateResizerLink from '@/utils/generateResizerLink';

export default function () {
  if (!this.event?.id) return {};

  // Проверить, существует ли тип ивента
  // И получить его название
  const types = this.$store?.state?.eventsList?.types || [];
  const typeSlug = this.event.type;

  const typeExists = types.includes(typeSlug);

  let key = 'default';
  if (typeExists) key = typeSlug;

  const type = this.$t(`eventos.type.${key}`);

  // Заголовок состоит из названия ивента и его типа
  const title = `EBAC ${type}: ${this.event.name}`;
  const descriptionPrefix = this.$t('eventos.description.prefix');
  const domain = this.$app.config.current.domain;
  const description = `${descriptionPrefix} "${this.event.name}", ${domain}`;

  // Если для ивента не заполнено изображение
  // взять превью с ютуба для трансляции выбранного топика
  let showcase = this.event.images?.showcaseImage?.url;
  if (showcase) {
    const resized = generateResizerLink({
      ext: 'jpeg',
      link: showcase,
      size: '1200x630',
    });
    if (resized) showcase = resized;
  }

  const broadcastId = this.activeTopic?.youtubeBroadcast?.broadcastId;
  const youtubePreview = `https://img.youtube.com/vi/${broadcastId}/hqdefault.jpg`;

  let image = '';

  if (!showcase && youtubePreview) image = youtubePreview;
  else if (showcase) image = showcase;

  return {
    bodyAttrs: {
      class: 'body--event',
    },
    title,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: description,
      },
      {
        hid: 'og:title',
        name: 'og:title',
        property: 'og:title',
        content: title,
      },
      {
        hid: 'og:image',
        name: 'og:image',
        property: 'og:image',
        content: image,
      },
      {
        hid: 'og:description',
        name: 'og:description',
        property: 'og:description',
        content: description,
      },
      {
        hid: 'og:site_name',
        name: 'og:site_name',
        property: 'og:site_name',
        content: 'EBAC Online',
      },
      {
        hid: 'og:url',
        name: 'og:url',
        property: 'og:url',
        content: `https://${this.$app.config.current.domain}${this.$route.path}`,
      },
      {
        hid: 'og:locale',
        name: 'og:locale',
        property: 'og:locale',
        content: this.$app?.config?.current?.localeName,
      },
      {
        hid: 'og:type',
        name: 'og:type',
        property: 'og:type',
        content: 'article',
      },
      {
        hid: 'og:article',
        name: 'og:article',
        property: 'og:article',
        content: 'https://ogp.me/ns/article#',
      },
      {
        hid: 'article:published_time',
        property: 'article:published_time',
        content: this.event?.created,
      },
      {
        hid: 'article:modified_time',
        property: 'article:modified_time',
        content: this.event?.modified,
      },
      !this.event.published && {
        hid: 'robots',
        name: 'robots',
        content: 'noindex, follow',
      },
    ].filter(Boolean),
  };
}
